if (!window.popupTriggerDelegated) {
  window.popupTriggerDelegated = true;

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('a[href^="#"]');
    if (!trigger) return;

    const id = decodeURIComponent(trigger.getAttribute('href').slice(1)).trim();
    if (!id) return;

    const popup = document.querySelector(`modal-dialog[data-popup-id="${CSS.escape(id)}"]`);
    if (!popup) return;

    event.preventDefault();
    popup.show(trigger);
  });
}
